import { useRef, useState } from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Form, Button, Modal } from "react-bootstrap";
import { QuestionCircleFill } from "react-bootstrap-icons";

export const CopyModel = ({
  templateName,
  machineService,
  handleOk,
  handleClose,
}) => {
  const intl = useIntl();

  const templateFormRef = useRef(null);
  const [name, setName] = useState(
    intl.formatMessage(
      { id: "page.templates.label.copytemplate.defaultvalue" },
      { name: templateName },
    ),
  );
  const [formValidated, setFormValidated] = useState(false);

  const createCopy = (event) => {
    event.preventDefault();
    setFormValidated(true);
    if (templateFormRef.current.checkValidity()) {
      handleOk(name, machineService);
    }
  };

  return (
    <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex">
          <QuestionCircleFill className="align-self-center me-2 text-info" />
          <span>
            <FormattedMessage id="page.templates.label.copytemplate.title" />
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormattedMessage
            id="page.templates.label.copytemplate.description"
            values={{ name: templateName }}
          />
        </div>
        <Form
          ref={templateFormRef}
          validated={formValidated}
          onSubmit={createCopy}
        >
          <Form.Control
            type="text"
            onChange={(e) => setName(e.target.value)}
            value={name}
            required={true}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          <FormattedMessage id="component.common.modal.button.cancel" />
        </Button>
        <Button variant="primary" onClick={createCopy}>
          <FormattedMessage id="component.common.modal.button.ok" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CopyModel.propTypes = {
  templateName: PropTypes.string.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
